jQuery.feature_import("js-order-assortment-locks",
    () => require("./OrderAssortmentLocks.jsx"),
    mod => mod.feature_js_order_assortment_locks
);